import { ReactNode } from 'react'

type InteractionGuardProps = {
  when: boolean
  onInteract?: (event: React.SyntheticEvent) => void
  children: ReactNode
  className?: string
  block?: boolean
}

export const InteractionGuard = ({
  when,
  onInteract,
  children,
  className,
  block = true,
}: InteractionGuardProps) => {
  const handleInteraction = (event: React.SyntheticEvent) => {
    if (!when) return
    if (block) {
      event.preventDefault()
      event.stopPropagation()
    }
    onInteract?.(event)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    handleInteraction(event)
  }

  return (
    <div
      className={className ? `contents ${className}` : 'contents'}
      onClickCapture={handleInteraction}
      onKeyDownCapture={handleKeyDown}
    >
      {children}
    </div>
  )
}
